import React, { useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import { addInternationalProduct } from "../../actions/International";

interface FormData {
    brand_id: number;
    name: string;
    description: string;
    image: File | null;
    hd_image: File | null;
    tasting_notes: File | null;
}

function AddInternationalProduct() {

    const [isCollapsed, setIsCollapsed] = useState(true);
    const location = useLocation();
    const user = location.state?.user;
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();

    const [formData, setFormData] = useState<FormData>({
        brand_id: Number(id),
        name: "",
        description: "",
        image: null,
        hd_image: null,
        tasting_notes: null,
    });

    const [imagePreview, setImagePreview] = useState<{[key: string]: string | null}>({
        image: null,
        hd_image: null
    });

    const handleInputChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const { name, type } = e.target;

        if (type === "file") {
            const file = (e.target as HTMLInputElement).files?.[0] || null;
            setFormData(prev => ({ ...prev, [name]: file }));

            // Only preview images
            if (file && name !== "tasting_notes") {
                setImagePreview(prev => ({ ...prev, [name]: URL.createObjectURL(file) }));
            }
        } else {
            setFormData(prev => ({ ...prev, [name]: (e.target as HTMLInputElement).value }));
        }
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        try {
            const payload = new FormData();
            Object.entries(formData).forEach(([key, value]) => {
                payload.append(key, value instanceof File ? value : value ?? "");
            });

            const response = await addInternationalProduct(payload, Number(id));

            if (response.status === 201) {
                alert("Product successfully added!");
                navigate(`/dashboard/international/brands/${id}/products`, { state: { user } });
            }

        } catch (error) {
            console.error("Submit Error:", error);
            alert("Something went wrong submitting the form");
        }
    };

    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />

            <div className={`main-admin-page ${isCollapsed ? "collapsed" : "expanded"}`}>
                <h2>Add International Product</h2>

                <form onSubmit={handleSubmit} encType="multipart/form-data"
                      style={{ display:"flex", flexDirection:"column", gap:"15px" }}>

                    {/* NAME */}
                    <input
                        type="text"
                        className="input-email"
                        placeholder="Product Name"
                        name="name"
                        value={formData.name}
                        onChange={handleInputChange}
                        required
                    />

                    {/* DESCRIPTION */}
                    <textarea
                        className="input-email"
                        placeholder="Description"
                        name="description"
                        value={formData.description}
                        onChange={handleInputChange}
                        rows={6}
                        style={{ resize:"vertical" }}
                        required
                    />

                    {/* IMAGE */}
                    <label>Product Image</label>
                    <input type="file" name="image" accept="image/*" onChange={handleInputChange} />
                    {imagePreview.image && <img src={imagePreview.image} style={{width:"150px", marginTop:"10px"}} />}

                    {/* HD IMAGE */}
                    <label>HD Image</label>
                    <input type="file" name="hd_image" accept="image/*" onChange={handleInputChange} />
                    {imagePreview.hd_image && <img src={imagePreview.hd_image} style={{width:"150px", marginTop:"10px"}} />}

                    {/* PDF */}
                    <label>Tasting Note (PDF)</label>
                    <input type="file" name="tasting_notes" accept="application/pdf" onChange={handleInputChange} />
                    {formData.tasting_notes && <p>📄 {formData.tasting_notes.name}</p>}

                    <button type="submit" className="btn btn-success">Add Product</button>
                </form>
            </div>
        </div>
    );
}

export default AddInternationalProduct;
